import { render, staticRenderFns } from "./Pocasi.vue?vue&type=template&id=4657e708&scoped=true&"
import script from "./Pocasi.vue?vue&type=script&lang=js&"
export * from "./Pocasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657e708",
  null
  
)

export default component.exports